export function shouldAutoFocus(autoFocus, order) {
  return autoFocus !== false && order !== 1
}
